// extracted by mini-css-extract-plugin
module.exports = {"layout":"dd31006766--layout--NKfN5"};